"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = handleCartWarnings;
var _uxTreadNewRelic = require("@nike/ux-tread-new-relic");
var _sharedUtils = require("./shared-utils");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var EVENT_NAME = 'Handling Cart Warning';

/**
 * All possible warning codes from buy/carts/v2 service:
 * - PRICE_CHANGED: Product price has changed
 * - QUANTITY_MODIFIED: Item quantity was adjusted
 * - PRODUCT_REMOVED: Product was removed from cart
 * - PROMOTION_NOT_APPLIED: Promotion code could not be applied
 * - COUNTRY_NOT_SUPPORTED: Country is not supported for this operation
 */

/**
 * Warning codes that should be displayed to users
 * Other warnings are logged but not displayed
 */
var DISPLAYABLE_WARNING_CODES = {
  COUNTRY_NOT_SUPPORTED: true,
  PROMOTION_NOT_APPLIED: true
};

/**
 * Warning codes that require auto-remediation
 */
var PROMO_CODE_WARNING_CODES = {
  PROMOTION_NOT_APPLIED: true
};

/**
 * Handles warnings returned from the buy/carts/v2 service
 * Logs all warnings to New Relic, removes invalid promo codes, and displays specific warnings to users
 * @param {Object} params - Parameters object
 * @param {Array} params.warnings - Array of warning objects from API response
 * @param {Object} params.data - Cart data from API response
 * @param {Object} queryClient - React Query client instance
 * @param {string} [params.promotionCode] - attempted promo code from mutation variables
 * @returns {Promise<Array>} The warnings array for potential upstream handling
 */
function handleCartWarnings(_x, _x2) {
  return _handleCartWarnings.apply(this, arguments);
}
function _handleCartWarnings() {
  _handleCartWarnings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, queryClient) {
    var warnings, data, promotionCode, invalidPromoCodes, hasPromoNotAppliedWarning, fallbackPromoCodes, promoCodesToRemove, handleRemovePromotionCode;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          warnings = _ref.warnings, data = _ref.data, promotionCode = _ref.promotionCode;
          if (!(!warnings || !Array.isArray(warnings) || warnings.length === 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, warnings);
        case 1:
          // Extract invalid promo codes from warnings
          invalidPromoCodes = warnings.filter(function (warning) {
            return warning.field && typeof warning.field === 'string';
          }).reduce(function (accum, warning) {
            if (PROMO_CODE_WARNING_CODES[warning.code]) {
              try {
                // Convert field path (e.g., '/promotionCodes/0') to dot notation (e.g., 'promotionCodes.0')
                var fieldPath = warning.field.split('/').filter(function (x) {
                  return x;
                }).join('.');
                if (fieldPath) {
                  var promoCode = (0, _sharedUtils.getByPath)(data, fieldPath);
                  if (promoCode && typeof promoCode === 'string') {
                    return [].concat(_toConsumableArray(accum), [promoCode]);
                  }
                }
              } catch (fieldError) {
                (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
                  error: 'Error extracting promo code from warning field',
                  field: warning.field,
                  code: warning.code,
                  message: warning.message,
                  fieldError: fieldError.message
                });
              }
            }
            return accum;
          }, []);
          hasPromoNotAppliedWarning = warnings.some(function (warning) {
            return warning && PROMO_CODE_WARNING_CODES[warning.code];
          });
          fallbackPromoCodes = hasPromoNotAppliedWarning && promotionCode && typeof promotionCode === 'string' ? [promotionCode] : [];
          promoCodesToRemove = invalidPromoCodes.length > 0 ? invalidPromoCodes : fallbackPromoCodes; // Remove invalid promo codes if any found
          if (!(promoCodesToRemove.length > 0)) {
            _context.n = 3;
            break;
          }
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            action: 'Removing invalid promotion codes from warnings',
            promotionCodes: promoCodesToRemove
          });
          _context.n = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 2:
          handleRemovePromotionCode = _context.v["default"];
          _context.n = 3;
          return handleRemovePromotionCode({
            promotionCode: promoCodesToRemove[0],
            queryClient: queryClient
          });
        case 3:
          // Log and display each warning
          warnings.forEach(function (warning) {
            var code = warning.code,
              message = warning.message,
              crcCode = warning.crcCode,
              field = warning.field;

            // Log all warnings to New Relic for monitoring
            (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
              warningCode: code,
              warningMessage: message,
              crcCode: crcCode,
              field: field,
              data: data
            });

            // Only display specific warning types to users
            if (DISPLAYABLE_WARNING_CODES[code]) {
              var _window$NikeShop;
              if ((_window$NikeShop = window.NikeShop) !== null && _window$NikeShop !== void 0 && (_window$NikeShop = _window$NikeShop.__INTERNAL_USE__) !== null && _window$NikeShop !== void 0 && (_window$NikeShop = _window$NikeShop.stores) !== null && _window$NikeShop !== void 0 && _window$NikeShop.errorModal) {
                window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(warning);
              }
            }
          });
          return _context.a(2, warnings);
      }
    }, _callee);
  }));
  return _handleCartWarnings.apply(this, arguments);
}